import { canAccessNotificationCenter } from "../../NotificationCenter/utils/notificationCenterAccess";

export function canAccessClientNotificationCenter(user) {
  return (
    Boolean(user) &&
    typeof user === "object" &&
    Object.keys(user).length > 0 &&
    !canAccessNotificationCenter(user)
  );
}
